import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus, removeNonNumeric } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import FilterIcon from "assets/icon/FilterIcon";
import XIcon from "assets/icon/XIcon";
import moment from "moment";
import SortIcon from "assets/icon/SortIcon";
import { useModal } from "context/ModalContext";
import Pagination from "components/Input/PaginationButton";
import { useCallApi } from "api/apiHooks";
import { FilterCard, PagesTitle } from "components/Cards";

export default function Customer(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerList, fetchDeleteCustomer } = useCallApi()

    const [customerList, setCustomerList] = useState([])
    const [customerName, setCustomerName] = useState(EmptyString)
    const [address, setAddress] = useState(EmptyString)
    const [phone, setPhone] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [sortDirection, setSortDirection] = useState(true) // true = asc, false = desc
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    
    const customerNameChange = (e) => {setCustomerName(e.target.value.toUpperCase())}
    const addressChange = (e) => {setAddress(e.target.value.toUpperCase())}
    const phoneChange = (e) => {setPhone(removeNonNumeric(e.target.value))}
    const statusChange = (e) => {setStatus(e.value)}
    const isFilterOpenClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchCustomerList(customerName, address, phone, status, PageSize, parseInt(newIndex))

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setCustomerList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }
    
    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}
    const searchBtnClick = () => {
        handlePageChange(0)
    }
    const addBtnClick = () => {
        navigate("/customer/form?customerId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (customerId) => {
        navigate("/customer/form?customerId=" + customerId + "&formType=Edit")
    }
    const deleteBtnClick = async (customerId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteCustomer(customerId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }
    const sortBtnClick = (item) => {
    }

    useEffect(() => {
        handlePageChange(0)
    },[status])

    return(
        <div className="flex flex-col gap-2">
            <PagesTitle title='Pelanggan' />

            <div className="xl:hidden mt-5 flex justify-end">
                <button className="bg-black rounded-md flex gap-2 px-4 py-2" onClick={isFilterOpenClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`flex flex-col xl:flex-row gap-5 justify-between mt-2 ${isFilterOpen ? 'flex' : 'hidden xl:flex'}`}>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Nama Pelanggan'>
                        <input className="input" value={customerName} onChange={customerNameChange} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title='Phone'>
                        <input className="input" value={phone} onChange={phoneChange} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title='Status' width='w-full sm:w-32'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} />
                    </FilterCard>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="hidden xl:block mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Customer Name</th>
                            <th className="font-semibold text-left px-2">Address</th>
                            <th className="font-semibold text-left px-2">Phone</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold text-left">
                                <div className="flex gap-2 items-center">
                                    Create Date
                                    <button className="bg-black p-2 rounded-md" onClick={() => { sortBtnClick("CreateDate") }}>
                                        <SortIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </th>
                            <th className="font-semibold text-left px-2">Create By</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {customerList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.customerName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.address }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.phone }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ moment(data.createDate).format("DD MMM yyyy") }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.updateBy }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick(data.customerId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <div className="block xl:hidden mt-5">
                <div className="flex flex-col gap-3">
                    {customerList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="flex justify-between border bg-white p-3">
                                <div className="flex flex-col">
                                    <label className="text-sm">{data.customerName.toUpperCase()}</label>
                                    <label className="text-sm">{data.address === EmptyString ? "- " : data.address}</label>
                                    <label className="text-sm">{data.phone}</label>
                                </div>
                                <div className="flex flex-col gap-2 justify-between">
                                    <button className="button flex gap-2" onClick={() => editBtnClick(data.customerId)}>
                                        <EditIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerId, data.status)}>
                                        <TrashIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerId, data.status)}>
                                        <RevisionIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    )
}